import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/suppliers'
import Component from 'components/Suppliers'

export default createListViewContainer({ actions, selectors: selectors.suppliers })(Component)
